import type { ReactElement } from "react";

import type { SignalEventType } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/types";

import { StyledChip, StyledChipText } from "./styles";

type Props = {
    type: SignalEventType;
    children: ReactElement | string;
    onClick?(): void;
};

const SignalTypeTag = (props: Props) => {
    const { type, children, onClick } = props;

    return (
        <StyledChip
            data-automation-type={type}
            onClick={onClick}
        >
            <StyledChipText>{children}</StyledChipText>
        </StyledChip>
    );
};

export default SignalTypeTag;
